import { VAvatar } from 'vuetify/lib/components/VAvatar';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VAvatar,{attrs:{"color":_vm.color,"size":_vm.size,"min-width":_vm.size,"min-height":_vm.size,"left":_vm.left}},[(_vm.imgerror)?_c('span',{style:('color: ' + _vm.text_color)},[_vm._v("\n\t\t"+_vm._s(_vm.image_code)+"\n\t")]):_vm._e(),(!_vm.imgerror)?_c('img',{attrs:{"src":_vm.image},on:{"error":function($event){_vm.imgerror = true}}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }